import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-toolbar-logo',
  templateUrl: './toolbar-logo.component.html',
  styleUrls: ['./toolbar-logo.component.scss'],
  standalone: false
})
export class ToolbarLogoComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
